import styled from "styled-components";
import TopHeader from './components/TopHeader';
import logo from './logo.svg';
import { useEffect, useState} from "react";
import Flex from "../Flex";

const StyledHeader = styled.header`
display: flex;
justify-content: space-between;
align-items: center;
padding: 20px 10px 0 10px;
@media ${props => props.theme.media.smallScreen}{
    
}
@media ${props => props.theme.media.tablet}{
    display: flex;
    flex-direction: column;
} 
@media ${props => props.theme.media.phone}{
    display: flex;
    flex-direction: column;
 }

`
const SmallHeadersColumn = styled.div`
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
`
const StyledLogoImg = styled.img`
width: 40px;
height: auto;
`
const StyleLogoText = styled.h2`
font-size: 22px;
color: #fff;
margin-left: 10px;
@media ${props => props.theme.media.smallScreen}{
    
}
@media ${props => props.theme.media.tablet}{
   
} 
@media ${props => props.theme.media.phone}{
    font-size: 28px;
 }
`
const StyleLogo= styled.div`
display: flex;
align-items: center;
justify-content: center;
`
const StyleClock = styled.p`
font-size: 18px;
color: #fff;
@media ${props => props.theme.media.smallScreen}{
    
}
@media ${props => props.theme.media.tablet}{
    display: flex;
    justify-content: center;
    margin-top: 20px;
    font-size: 20px;
    font-weight: 700;
    &:last-child{
        margin:0;
    }
 }
} 
@media ${props => props.theme.media.phone}{
    display: flex;
    justify-content: center;
    margin-top: 20px;
    font-size: 20px;
    font-weight: 700;
    &:last-child{
        margin:0;
    }
 }
`

const Header = ({rateNow}) =>{

   
    const[clock, setClock] = useState(null)
    const [day, setDay] = useState(null)
    

 
    
    useEffect(()=>{
        let date = new Date();
        let day = date.getDate()
        let weekDay = date.getDay();
        let month = date.getMonth();
        let year = date.getFullYear();
        
        const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const months = ['January', 'February', 'March', 'April', 'May','June', 'July' , 'August', 'September', 'October', 'November', 'December'];
        let fullDate = weekDays[weekDay] + ' the ' + day + 'th ' + 'of ' + months[month] + ' ' + year;
       setDay(fullDate)
        
      
            
        setInterval(() =>{
        let date = new Date();
        let hours = date.getHours();
            if (hours< 10){
                hours = '0' + hours;
            }
        let minutes = date.getMinutes();
            if (minutes< 10){
                minutes = '0' + minutes;
            }
        let seconds = date.getSeconds();
            if (seconds< 10){
                seconds = '0' + seconds;
            }
        let time = hours + ':' + minutes + ':' + seconds;
        
        setClock(time)
        }, 1000)
    },[]);
   
    
    


    return(
        <StyledHeader>
            <StyleLogo><StyledLogoImg src={`${logo}`} alt="logo"/><StyleLogoText>Currency <br /> Converter App</StyleLogoText></StyleLogo>
            <SmallHeadersColumn>
                <TopHeader rateNow={rateNow}/>
            </SmallHeadersColumn>
            
            <Flex justifyContent='center' alignItems='center' direction='column' >
                <StyleClock>{day}</StyleClock> 
                <StyleClock> {clock}</StyleClock>
            </Flex>
        </StyledHeader>
       
    )
}

export default Header;